const routes = [
  {
    path: "/jlbWxMapMain",
    name: "jlbWxMapMain",
    component: () => import("../mapMain.vue"),
    meta: {
      title: "玖龙智通管理系统",
      keepAlive: true
    }
  },
  {
    path: "/jlbWxMapDetailList",
    name: "jlbWxMapDetailList",
    component: () => import("../mapDetailList.vue"),
    meta: {
      title: "玖龙智通管理系统",
      keepAlive: false
    }
  },
  {
    path: "/jlbWxMapAchievement",
    name: "jlbWxMapAchievement",
    component: () => import("../achievement.vue"),
    meta: {
      title: "玖龙智通管理系统",
      keepAlive: true
    }
  },
  {
    path: "/jlbWxMapAchievementList",
    name: "jlbWxMapAchievementList",
    component: () => import("../achievementList.vue"),
    meta: {
      title: "玖龙智通管理系统",
      keepAlive: false
    }
  }
];

export default routes;
